// extracted by mini-css-extract-plugin
module.exports = {"rating":"rating_rating__1KnU2"};